import { NotificationDTO } from '@inversor-hub/types';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import isToday from 'dayjs/plugin/isToday';
import isYesterday from 'dayjs/plugin/isYesterday';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import weekday from 'dayjs/plugin/weekday';

dayjs.extend(relativeTime);
dayjs.extend(isToday);
dayjs.extend(isYesterday);
dayjs.extend(isSameOrAfter);
dayjs.extend(weekday);

export function groupNotifications(notifications: NotificationDTO[]) {
  const today: NotificationDTO[] = [];
  const yesterday: NotificationDTO[] = [];
  const week: NotificationDTO[] = [];
  const before: NotificationDTO[] = [];
  const startOfWeek = dayjs().weekday(0);

  notifications.forEach((n) => {
    const date = dayjs(n.createdAt);
    if (date.isToday()) today.push(n);
    else if (date.isYesterday()) yesterday.push(n);
    else if (date.isSameOrAfter(startOfWeek)) week.push(n);
    else before.push(n);
  });
  return [
    { label: 'Hoy', items: today },
    { label: 'Ayer', items: yesterday },
    { label: 'Esta semana', items: week },
    { label: 'Anteriores', items: before },
  ];
}
